
/*eslint-disable no-console */
import {
  ApplicationName as StoreActivityTrackingApplicationName,
  ApplicationNameForStoreServices,
  ShopPermissionName,
  PlatformService,
  Components, Links,
  MicrosoftCspPex
} from '@telstra-connect/self-service-store/activity-tracking'
import { IUserProfile } from '@telstra-connect/login/state'
import { IAuthorizedRequestState } from '@telstra-connect/utils/http/requests/request'
import { IStoreIntAppStateObject } from '@telstra-connect/self-service-store/state'
import { IApplicationDefinition, IAppRegistry } from '@apps-config/app-definition'
import { RoutesHelper } from '@apps-config/routing/routing'
import { Activity } from '@utils/activity-tracking'
import { isObject } from '@utils/isObject'
import { secureRouteBuilder } from '../secure-route'
import Routes from './route-constants'
import { platformAppName } from '@telstra-connect/utils/data/platform-data'
import { NotAuthorisedError, NotFoundError } from './components/error-page'
import StoreServiceContainer from './cards/store-services/index-lazy'
import { IntNetWorkLandingPage } from './pages/networks-landing/index-lazy';
import { IntStoreLanding } from './pages/int-store/dashboard/index-lazy'
import { CrossConnectLandingPage } from './pages/cross-connect/index-lazy'
import { OrderSummaryPage } from './pages/order-summary/index-lazy'
import { CheckoutPage } from './pages/checkout/index-lazy'
import { OrderSubmission } from './pages/order-submission/index-lazy'
import { SavedCartPage } from './pages/saved-cart/index-lazy'
import { isInternationalCustomer, getCompanyId, getCompanyIdOnInit } from '@applications/utility-methods'
import { ManageSubscriptionPage } from './pages/manage-subscription/index-lazy'
import { CartPage } from './pages/cart/index-lazy';

const routes = new RoutesHelper({
  rootPath: secureRouteBuilder(`${Routes.selfServiceStore}`),
  subpagesPathMask: secureRouteBuilder(Routes.selfServiceStore),
})
const menuItemName = 'Shop';

export const mobileDataUsageMeterRoute = routes.getAppPath()

const applicationName = StoreActivityTrackingApplicationName
const tracker = Activity.createTracker(applicationName)
export const trackerForStoreIntServices = Activity.createTracker(ApplicationNameForStoreServices)
const MDUM_APPNAME = StoreActivityTrackingApplicationName

export function isStoreIntAvailable() {
  // tslint:disable-next-line: no-string-literal
  // tslint:disable-next-line: no-string-literal
  const servicesConfig = window['applications']

  if (servicesConfig == null) {
    return false
  }

  if (servicesConfig[ShopPermissionName] &&
    isObject(servicesConfig[ShopPermissionName]) &&
    servicesConfig[PlatformService] &&
    servicesConfig[PlatformService].storeInt
  ) {
    return true
  }
  if (servicesConfig[PlatformService] && servicesConfig[PlatformService].intShopAccessForMicrosoftCSPService) {
    if (servicesConfig[MicrosoftCspPex] &&
      isObject(servicesConfig[MicrosoftCspPex])
    ) {
      return true
    }
  }

  return false
}

export function shouldEnableSubmitBugLink() {
  // FIXME: window['applications'] is used as global object need to pass this a param
  // pass this a to MFE's and other subapplications platform
  // tslint:disable-next-line: no-string-literal
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  // FIXME: added below line by discussing with Somesh as no clear understanding with SRM_APPNAME and IM_APPNAME.
  if (isObject(servicesConfig[applicationName]) && isObject(servicesConfig[MDUM_APPNAME])) {
    return true
  }
  return false
}

export function getRedesignDataRichTileFlag() {
  // FIXME: window['applications'] is used as global object need to pass this a param
  // pass this a to MFE's and other subapplications platform

  // tslint:disable-next-line: no-string-literal
  const servicesConfig = window['applications']
  if (servicesConfig == null) {
    return false
  }
  if (
    isObject(servicesConfig[platformAppName]) &&
    servicesConfig[platformAppName].redesignDataRichTiles
  ) {
    return true
  }
  return false
}

export const Application: IApplicationDefinition = {
  get applicationName() {
    return applicationName
  },

  get acceptsUserFeedback() {
    return true
  },

  get acceptsErrorReports() {
    return true
  },

  get card() {
    const isStoreAvailableFlag = isStoreIntAvailable()
    // check for new flag

    if (isStoreAvailableFlag) {
      return StoreServiceContainer
    }
  },

  get tracker() {
    return tracker
  },

  get trackerForStoreIntServices() {
    return trackerForStoreIntServices
  },

  get routes() {
    return routes
  },

  init(registry: IAppRegistry,
    availableToUser: boolean,
    userProfile: IUserProfile,
    authorizedRequestState: IAuthorizedRequestState
  ) {
    availableToUser = true
    const companyId = getCompanyIdOnInit(userProfile, authorizedRequestState)
    const isInternational = isInternationalCustomer(companyId)
    const isStoreIntEnabledFlag = isStoreIntAvailable()
    const isMultiNational = window.localStorage.getItem("isMultinational");
    const parsedIsMultiNational = isMultiNational ? JSON.parse(isMultiNational) : false;

    if (isInternational && isStoreIntEnabledFlag && !parsedIsMultiNational) {
      registry.add(Application)
    }
  },

  render() {
    return [
      {
        path: routes.getPageSubpath(Routes.NotFound),
        component: NotFoundError,
      },
      {
        path: routes.getPageSubpath(Routes.NotAuthorised),
        component: NotAuthorisedError,
      },
      {
        path: routes.getPageSubpath(Routes.NetWorksLandingPageRoute),
        component: IntNetWorkLandingPage,
      },
      {
        path: routes.getPageSubpath(Routes.internationalStore),
        component: IntStoreLanding,
      },
      {
        path: routes.getPageSubpath(Routes.CrossConnectPageRoute),
        component: CrossConnectLandingPage,
      },
      {
        path: routes.getPageSubpath(Routes.OrderSubmissionPageRoute),
        component: OrderSubmission,
      },
      {
        path: routes.getPageSubpath(Routes.orderSummaryPageRoute),
        component: OrderSummaryPage,
      },
      {
        path: routes.getPageSubpath(Routes.CheckoutPageRoute),
        component: CheckoutPage,
      },
      {
        path: routes.getPageSubpath(Routes.savedCardRoute),
        component: SavedCartPage,
      },
      {
        path: routes.getPageSubpath(Routes.manageSubscriptionRoute),
        component: ManageSubscriptionPage
      },
      {
        path: routes.getPageSubpath(Routes.cartPageRoute),
        component: CartPage,
      },
    ]
  },


  menuItem(state) {
    const pagePath = Application.routes.getPageSubpath(Routes.internationalStore);
    const isStoreIntEnabledFlag = isStoreIntAvailable();
    const companyId = getCompanyId(state)
    const isInternational = isInternationalCustomer(companyId)
    // isMultinational - check, only show to internatiol single entity users
    // @ts-ignore: Unreachable code error
    const isMultinational = (state)?.support?.userProfileDetails?.data?.details?.isMultiNational ? true : false;

    window.localStorage.setItem("isMultinational", JSON.stringify(isMultinational));
    if (isInternational && isStoreIntEnabledFlag && !isMultinational) {
      return [
        {
          testID: 'ui-menu-store-int-web',
          name: 'Shop',
          intialPagePath: pagePath,
          appPath: routes.getAppPath(),
          onClick: () => {
            Application.tracker.trackMenu(menuItemName);
            Application.tracker.trackLink(Components.shopDashboardPage, Links.topMenuBarBtn);
          },
        },
      ];
    } else {
      return null;
    }
  },
}

type IStoreIntAppState = typeof IStoreIntAppStateObject

export { IStoreIntAppState, Routes }
